import { getIsMobileOrTablet } from '@office-start/device-detection-utility';
import { useMemo } from 'react';
import { useTeachingUiConfig } from './useTeachingUiConfig';
export function useTeachingUiEnabled() {
    var config = useTeachingUiConfig().data;
    var isMobileOrTablet = useMemo(function () { return getIsMobileOrTablet(); }, []);
    return useMemo(function () { return !(config === null || config === void 0 ? void 0 : config.hideInTestMode) && !isMobileOrTablet; }, [config, isMobileOrTablet]);
}
//# sourceMappingURL=useTeachingUiEnabled.js.map